import AboutUs from "components/aboutus/aboutus";
export default AboutUs;
